/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import React, { Suspense } from "react";

import LoadingScreen from "components/ui/LoadingScreen/LoadingScreen";
import { ROUTES_LIST } from "Router";
import { RouteManager } from "Router/RouterManagers";

const RoutesMapper = (route: string) => {
  const currentRoute = ROUTES_LIST[route as keyof typeof ROUTES_LIST];
  const path = currentRoute?.routeMap?.base;
  const Component = currentRoute?.component;
  if (!Component) return null;
  // Create a lazy-loaded component

  return {
    path: `${path}/*`,
    element: (
      <RouteManager>
        <Suspense fallback={<LoadingScreen />}>
          <Component />
        </Suspense>
      </RouteManager>
    ),
  };
};

export default RoutesMapper;
